export default __webpack_public_path__ + "static/media/fsk-21-b.41138826.jpg";